<div style="text-align:center">
 <p> Champion of this match is </p>
 <h1> {{winner.name}} </h1>
 <p> {{winner.score}} </p>
 <a href='/project/dribbler'> Start a new game </a>
</div>



// WEBPACK FOOTER //
// C:/Users/BHAJ/Desktop/dribbler/src/app/playwinner/playwinner.component.html